/* eslint-disable */
import * as Types from '../../../models/schema';

import { DomainFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateDomainVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
  data?: Types.Maybe<Types.DomainUpdateInputDTO>;
}>;


export type UpdateDomainDTO = (
  { __typename?: 'Mutation' }
  & { updateOneDomain: (
    { __typename?: 'Domain' }
    & DomainFragmentDTO
  ) }
);


export const UpdateDomainDocumentDTO = gql`
    mutation updateDomain($id: String!, $data: DomainUpdateInput) {
  updateOneDomain(id: $id, data: $data) {
    ...domainFragment
  }
}
    ${DomainFragmentDTO}`;
export type UpdateDomainMutationFnDTO = Apollo.MutationFunction<UpdateDomainDTO, UpdateDomainVariablesDTO>;

/**
 * __useUpdateDomain__
 *
 * To run a mutation, you first call `useUpdateDomain` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomain` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomain, { data, loading, error }] = useUpdateDomain({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDomain(baseOptions?: Apollo.MutationHookOptions<UpdateDomainDTO, UpdateDomainVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainDTO, UpdateDomainVariablesDTO>(UpdateDomainDocumentDTO, options);
      }
export type UpdateDomainHookResult = ReturnType<typeof useUpdateDomain>;
export type UpdateDomainMutationResultDTO = Apollo.MutationResult<UpdateDomainDTO>;
export type UpdateDomainMutationOptionsDTO = Apollo.BaseMutationOptions<UpdateDomainDTO, UpdateDomainVariablesDTO>;